export interface IPNSNavItem {
  displayName: string;
  requiredPrivilegeName?: string;
  disabled?: boolean;
  iconName?: string;
  expanded?: boolean;
  route?: string;
  children?: IPNSNavItem[];
}
